import { Injectable, Inject } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { DOCUMENT } from '@angular/common';
import { ProductService } from '../../products/product.service';

@Injectable()
export class SeoService {
  private indexHTML = {
    "title-en-us": "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "description-en-us":
      "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
    "title-compare-en-us":
      "Compare The Wide Range of High-Performance NVIDIA Products for Creators.",
    "description-compare-en-us":
      "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
      "title-en-ca": "The Wide Range of High-Performance NVIDIA Products for Creators.",
      "description-en-ca":
        "The Wide Range of High-Performance NVIDIA Products for Creators.",
      "title-compare-en-ca":
        "Compare The Wide Range of High-Performance NVIDIA Products for Creators.",
      "description-compare-en-ca":
        "The Wide Range of High-Performance NVIDIA Products for Creators.",
        "title-fr-ca":
          "The Wide Range of High-Performance NVIDIA Products for Creators.",
        "description-fr-ca":
          "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
        "title-compare-fr-ca":
          "Compare The Wide Range of High-Performance NVIDIA Products for Creators",
        "description-compare-fr-ca":
          "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
          "title-en-au": "The Wide Range of High-Performance NVIDIA Products for Creators.",
          "description-en-au":
            "The Wide Range of High-Performance NVIDIA Products for Creators.",
          "title-compare-en-au":
            "Compare The Wide Range of High-Performance NVIDIA Products for Creators.",
          "description-compare-en-au":
            "The Wide Range of High-Performance NVIDIA Products for Creators.",

    "title-en-gb": "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "description-en-gb":
      "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
    "title-compare-en-gb":
      "Compare The Wide Range of High-Performance NVIDIA Products for Creators.",
    "description-compare-en-gb":
      "Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions",
    "title-fr-fr":"NVIDIA",
    "description-fr-fr": "NVIDIA",
    "title-compare-fr-fr":
      "NVIDIA",
    "description-compare-fr-fr":
      "NVIDIA",
    "title-de-de": "NVIDIA",
    "description-de-de":
      "NVIDIA",
    "title-compare-de-de":
      "NVIDIA",
    "description-compare-de-de":
      "NVIDIA",
      "title-pl-pl": "NVIDIA",
      "description-pl-pl":
        "NVIDIA",
      "title-compare-pl-pl":
        "NVIDIA",
      "description-compare-pl-pl":
        "NVIDIA",

      "title-ru-ru": "NVIDIA",
      "description-ru-ru":"NVIDIA",
      "title-compare-ru-ru":"NVIDIA",
      "description-compare-ru-ru":"NVIDIA"
  };

  private configOG = {
    name: "NVIDIA",
    type: "Website",
    image:
      "https://www.nvidia.com/content/dam/en-zz/Solutions/studio/home/nvidia-studio-og-image-1200x630.jpg",
    "title-en-us": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-en-us":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-en-us": "https://store.nvidia.com/en-us/studio/store/",
    "title-en-ca": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-en-ca":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-en-ca": "https://store.nvidia.com/en-ca/studio/store/",
    "title-en-au": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-en-au":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-en-au": "https://store.nvidia.com/en-au/studio/store/",
    "title-en-gb": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-en-gb":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-en-gb": "https://store.nvidia.com/en-gb/studio/store/",
    "title-fr-fr": "Découvrez les cartes graphiques GeForce RTX",
    "description-fr-fr":
      "Découvrez GeForce RTX. Jouez avec la puissance phénoménale du ray tracing en temps réel.",
    "url-fr-fr": "https://store.nvidia.com/fr-fr/studio/store/",
    "title-de-de": "Wir stellen vor: GeForce GTX-Grafikkarten",
    "description-de-de":
      "GeForce RTX ist da. Einfach losspielen mit der Macht des Echtzeit-Raytracings.",
    "url-de-de": "https://store.nvidia.com/de-de/studio/store/",
    "title-pl-pl": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-pl-pl":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-pl-pl": "https://store.nvidia.com/en-us/studio/store/",

    "title-ru-ru": "Shop NVIDIA RTX Studio Laptops And Desktops",
    "description-ru-ru":
      "The Wide Range of High-Performance NVIDIA Products for Creators.",
    "url-ru-ru": "https://store.nvidia.com/ru-ru/studio/store/"
  };

  private configTwitter = {
    card: "summary_large_image",
    site: "@NVIDIACreators",
    creator: "@NVIDIA, @NVIDIAGeForce, @NVIDIADesign",
    image:
      "https://www.nvidia.com/content/dam/en-zz/Solutions/studio/home/nvidia-studio-og-image-1200x630.jpg",
    "title-en-us": "Shop NVIDIA RTX Studio Laptops And Desktops.",
    "description-en-us":
      "Explore The Wide Range Of High-Performance RTX Studio Laptops And Desktops For Creatives. Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions.",
    "url-en-us": "https://store.nvidia.com/en-us/studio/",
    "title-en-gb": "Shop NVIDIA RTX Studio Laptops And Desktops.",
    "description-en-gb":
      "Explore The Wide Range Of High-Performance RTX Studio Laptops And Desktops For Creatives. Powerful GPUs deliver the perfect canvas for creators to explore, create, and share their inspiring visions.",
    "url-en-gb": "https://store.nvidia.com/en-gb/studio/store/",
    "title-fr-fr": "Les cartes graphiques GeForce RTX sont disponibles",
    "description-fr-fr":
      "Cartes graphiques GeForce RTX avec ray tracing en temps réel. À vous de jouer !",
    "url-fr-fr": "https://store.nvidia.com/fr-fr/studio/store/",
    "title-de-de": "GeForce RTX-Grafikkarten sind da",
    "description-de-de":
      "Wir stellen vor: GeForce RTX-Grafikkarten mit Echtzeit-Raytracing. Das Spiel kann beginnen!",
    "url-de-de": "https://store.nvidia.com/de-de/studio/store/",
    "title-pl-pl": "Shop NVIDIA RTX Studio Laptops And Desktops.",
    "description-pl-pl":
      "The NVIDIA Studio platform supercharges your creative process with incredible boosts in performance.",
    "url-pl-pl": "https://store.nvidia.com/pl-pl/studio/store/"
  };

  constructor(private meta: Meta,
    private title: Title,
    @Inject(DOCUMENT) private doc,
    private productService: ProductService) {
  }

  generateTags(locale, isCompare) {
    if (!isCompare) {
      this.title.setTitle(`${this.indexHTML[`title-${locale}`]}`);
      this.meta.updateTag({
        name: "description",
        content: `${this.indexHTML[`description-${locale}`]}`
      });
    }

    if (isCompare) {
      this.title.setTitle(`${this.indexHTML[`title-compare-${locale}`]}`);
      this.meta.updateTag({
        name: "description",
        content: `${this.indexHTML[`description-compare-${locale}`]}`
      });
      this.removeCanonicalURL();
      this.createLinkForCanonicalURL(locale);
    }

    if (!isCompare) {
      this.removeCanonicalURL();
      this.createLinkForCanonicalURL(locale);
      this.meta.updateTag({
        property: "og:site_name",
        content: this.configOG.name
      });
      this.meta.updateTag({ property: "og:type", content: this.configOG.type });
      this.meta.updateTag({
        property: "og:url",
        content: isCompare
          ? `https://store.nvidia.com/${locale}/studio/store/compare/`
          : `https://store.nvidia.com/${locale}/studio/store/`
      });
      this.meta.updateTag({
        property: "og:title",
        content: `${this.configOG[`title-${locale}`]}`
      });
      this.meta.updateTag({
        property: "og:description",
        content: `${this.configOG[`description-${locale}`]}`
      });
      this.meta.updateTag({
        property: "og:image",
        content: this.configOG.image
      });

      this.meta.updateTag({
        name: "twitter:card",
        content: this.configTwitter.card
      });
      this.meta.updateTag({
        name: "twitter:site",
        content: this.configTwitter.site
      });
      this.meta.updateTag({
        name: "twitter:creator",
        content: this.configTwitter.creator
      });
      this.meta.updateTag({
        name: "twitter:title",
        content: `${this.configTwitter[`title-${locale}`]}`
      });
      this.meta.updateTag({
        name: "twitter:url",
        content: isCompare
          ? `https://store.nvidia.com/${locale}/studio/store/compare/`
          : `https://store.nvidia.com/${locale}/studio/store/`
      });
      this.meta.updateTag({
        name: "twitter:description",
        content: `${this.configTwitter[`description-${locale}`]}`
      });
      this.meta.updateTag({
        name: "twitter:image",
        content: this.configTwitter.image
      });
      this.meta.updateTag({
        name: "keywords",
        content: "NVIDIA Studio, best for creatives, 3D, video editing, rendering, animation, architecture, broadcasting, design, creative laptop, desktop, GeForce, TITAN, Quadro, Studio Drivers, GPU acceleration, RTX"
      });
    }

    if (isCompare) {
      this.meta.removeTag("property='og:site_name'");
      this.meta.removeTag("property='og:type'");
      this.meta.removeTag("property='og:url'");
      this.meta.removeTag("property='og:title'");
      this.meta.removeTag("property='og:description'");
      this.meta.removeTag("property='og:image'");

      this.meta.removeTag("name='twitter:card'");
      this.meta.removeTag("name='twitter:site'");
      this.meta.removeTag("name='twitter:creator'");
      this.meta.removeTag("name='twitter:title'");
      this.meta.removeTag("name='twitter:url'");
      this.meta.removeTag("name='twitter:description'");
      this.meta.removeTag("name='twitter:image'");

      this.meta.removeTag("name='keywords'");
    }
  }

  createLinkForCanonicalURL(locale) {
    let link: HTMLLinkElement = this.doc.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.doc.head.appendChild(link);
    link.setAttribute('href', `https://store.nvidia.com/${locale}/studio/store/`);
  }

  removeCanonicalURL() {
    var links = this.doc.head.getElementsByTagName("link");
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute("rel") && link.getAttribute("rel").indexOf("canonical") != -1) {
        link.remove();
      }
    }
  }

}
